<template>
  <div>
    <div class="mainContent">
      <div class="mainContent__paragraphs">
        <p>{{ fieldGroup.description }}</p>
      </div>

      <div v-if="hasGeneral">
        <h2 v-if="hasBoth" class="mainContent__title">Geral</h2>
        <component :is="specificComponent" ref="generalComponent" :fields="fieldGroup.general" v-model="app_config_part.general" />
      </div>

      <div v-if="loaded && hasPerWarehouse">
        <h2 v-if="hasBoth" class="mainContent__title">Por CD</h2>
        <div class="per_warehouse">
          <sc-warehouses-list ref="warehouseListComponent" 
            :editable="false" 
            :configurable="true" 
            :fields="fieldGroup.per_warehouse"
            :specificComponent="specificComponent"
            :currentWarehouseValue="currentWarehouseValue"
          />
        </div>
      </div>

    </div>
    <help-button />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScButton,
  ScForm,
  ScToast,
} from '@intelipost-js/secure-components';
import ScWarehousesList from '../warehouse/ScWarehousesList.vue';
import HelpButton from './HelpButton.vue';

const { mapMutations, mapState } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);

export default {
  name: 'sc-config-warehouse',
  components: {
    ScButton,
    ScForm,
    ScToast,
    ScWarehousesList,
    HelpButton,
  },
  props: {
    fieldGroupName: {
      type: String,
      required: true,
    },
    fieldGroup: {
      type: Object,
      required: true,
    },
    specificComponent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      hasGeneral: false,
      hasPerWarehouse: false,
      hasBoth: false,
      currentWarehouseValue: null,
      app_config_part: {
        general: {},
        per_warehouse: [],
      },
    };
  },
  created() {
    this.hasGeneral = this.fieldGroup.general.length > 0;
    this.hasPerWarehouse = this.fieldGroup.per_warehouse.length > 0;
    this.hasBoth = this.hasGeneral && this.hasPerWarehouse;
  },
  mounted() {
    this.$root.$on('select-warehouse', warehouse =>
      this.onSelectWarehouse(warehouse),
    );
    this.$root.$on('remove-warehouse', warehouse =>
      this.onRemoveWarehouse(warehouse),
    );
    this.$root.$on('add-warehouse', warehouse =>
      this.onAddWarehouse(warehouse),
    );
  },
  computed: {
    ...mapState([
      'appConfig',
    ]),
  },
  methods: {
    ...mapMutations([
      'setLoading',
      'setAppConfig',
    ]),

    refresh() {
      this.loaded = true;
    },

    onAddWarehouse(warehouse) {
      const TRANSFORMED_FEDERAL_TAX_PAYER_ID = warehouse.federal_tax_payer_id.replace(/\D/g, '');

      this.app_config_part.per_warehouse.push({
        warehouse_id: warehouse.id,
        cnpj_rem: TRANSFORMED_FEDERAL_TAX_PAYER_ID,
      });
    },
    onSelectWarehouse(warehouse) {
      this.currentWarehouseValue = this.app_config_part.per_warehouse
        .find(config => config.warehouse_id === warehouse.id);
    },
    onRemoveWarehouse(warehouse) {
      this.app_config_part.per_warehouse = this.app_config_part.per_warehouse
        .filter(config => config.warehouse_id !== warehouse.id);

      this.currentWarehouseValue = null;
    },
    invalidate() {
      this.invalidateGeneral();
    },
    invalidateGeneral() {
      if (this.hasGeneral && this.$refs.generalComponent.invalidate) {
        this.$refs.generalComponent.invalidate();
      }
    },
    validate() {
      const validatedGeneral = !this.hasGeneral || this.validateGeneral();
      const validatedPerWarehouse = !this.hasPerWarehouse || this.validatePerWarehouse();

      if (!validatedGeneral || !validatedPerWarehouse) {
        ScToast.open({
          message: 'Corrija os campos destacados antes de prosseguir.',
          type: 'is-danger',
        });
        return false;
      }

      return true;
    },

    validateGeneral() {
      if (!this.$refs.generalComponent.validateConfig(this.app_config_part.general)) {
        return false;
      }
      return true;
    },

    validatePerWarehouse() {
      for (let index = 0; index < this.app_config_part.per_warehouse.length; index += 1) {
        const config = this.app_config_part.per_warehouse[index];
        if (!this.$refs.warehouseListComponent.validateConfig(config, index)) {
          this.$refs.warehouseListComponent.setSelectedWarehouse(config.warehouse_id);
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style lang='scss' scoped>
.mainContent {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__paragraphs {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__title {
    margin-bottom: 10px;
    font-size: 120%;
    font-weight: bold;
  }
}
.per_warehouse {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/base/ScFieldGroup.vue